module.exports = __webpack_public_path__ + "static/media/github.c1356d39.svg";